// extracted by mini-css-extract-plugin
export default {"placeholder":"brand_placeholder__GhwY6","container":"brand_container__HNIdg","productsWrapper":"brand_productsWrapper__sS8vr"};